import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CheckEligibility } from 'src/app/models/check-eligibility';
import { TrainingEligibilityForm } from 'src/app/models/training-eligibility-form.model';
import { environment } from 'src/environments/environment';
import { TrainingEligibilityInterface } from './training-eligibility.interface';


@Injectable({
  providedIn: 'root'
})
export class TrainingEligibilityService implements TrainingEligibilityInterface {

  constructor(private httpClient: HttpClient) { }

  CheckPersonFound(trainingEligibilityForm: TrainingEligibilityForm): Observable<boolean> {
    return this.httpClient.post<any>(environment.apiBaseUrl + `trainingeligibility/CheckPersonFound`, trainingEligibilityForm);
  }

  CheckEligibility(trainingEligibilityForm: TrainingEligibilityForm): Observable<CheckEligibility> {
    return this.httpClient.post<any>(environment.apiBaseUrl + `trainingeligibility/CheckEligibility`, trainingEligibilityForm);
  }
}
